import React from "react";
import { CategoryResult } from "../../interfaces/ICompetitions";
import { Grid, TableCell, Typography } from "@mui/material";

interface CategoryTableRowProps {
  category: CategoryResult;
  competitionId: string;
}

function CategoryTableRow({ category }: CategoryTableRowProps) {
  return (
    <TableCell sx={{ py: 1.5 }}>
      <Grid container spacing={1}>
        <Grid item xs={12} sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography
            variant="subtitle1"
            component="div"
            color="primary"
            sx={{
              fontWeight: 600,
              fontSize: { xs: "0.875rem", sm: "0.9375rem" },
              lineHeight: 1.3,
              wordBreak: "break-word",
              mb: { xs: 0.5, sm: 0 },
            }}
          >
            {category.name}
          </Typography>
        </Grid>
      </Grid>
    </TableCell>
  );
}

export default React.memo(CategoryTableRow);
